import type { EmployeeDesignation } from '../types';
import { isDesignerRole } from './userRoles';

export function canSubmitArchitectStandup(authRole: string | undefined): boolean {
  return isDesignerRole(authRole) || authRole === 'admin';
}

/** Leadership + PMs who may read architect standup reports on Project Hub. */
export function canViewArchitectStandupReports(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (args.authRole === 'admin') return true;
  if (args.authRole !== 'employee') return false;
  const d = args.designations;
  if (!d?.length) return false;
  return d.includes('project_manager') || d.includes('coo') || d.includes('cfo');
}
